export default __webpack_public_path__ + "static/media/soundjaybeep-07a.250aa10d.mp3";